export default "__VITE_ASSET__DD2D3eOl__"